/**
 * Import Service
 * Handle bulk data imports
 */

import api from '../lib/api';

export const importService = {
  /**
   * Get all available import fields
   */
  async getFields() {
    const response = await api.get('/import/fields');
    return response.data;
  },

  /**
   * Get preview of CSV data with suggested column mappings
   */
  async previewParents(csvContent, delimiter = ',', importType = 'parents_and_students') {
    const response = await api.post('/import/preview', {
      csvContent,
      delimiter,
      importType
    });
    return response.data;
  },

  /**
   * Validate CSV data with user-provided mappings
   */
  async validateParents(csvContent, mappings, importType = 'parents_and_students', delimiter = ',') {
    const response = await api.post('/import/validate', {
      csvContent,
      mappings,
      importType,
      delimiter
    });
    return response.data;
  },

  /**
   * Execute the import
   */
  async importParents(csvContent, mappings, options = {}) {
    const { delimiter = ',', skipInvalid = false, updateExisting = false, importType = 'parents_and_students' } = options;
    const response = await api.post('/import/execute', {
      csvContent,
      mappings,
      delimiter,
      options: { skipInvalid, updateExisting, importType }
    });
    return response.data;
  },

  /**
   * Download CSV template
   */
  downloadTemplate(type = 'parents_and_students') {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    window.open(`${apiUrl}/import/templates/${type}`, '_blank');
  }
};
